import * as yup from "yup";

export default yup.object().shape({
  name: yup.string().required().label("Name"),
  instance_url: yup.string().nullable().url().notRequired().label("Instance URL"),
  login_url: yup.string().url().required().label("Login URL"),
  is_active: yup.boolean().default(true).label("Active"),
  organization_id: yup.number().required().label("Organization ID"),
});
